import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { AuthDomainService } from '@app/auth/domain/auth-domain.service';
import { Observable } from 'rxjs';
import { User } from '@app/utils/models/user/user.model';

function loginFromStorage(authService: AuthDomainService) {
  return (): Observable<User | null> => authService.loginFromStorage$();
}

export const authInitializerProvider: EnvironmentProviders = provideAppInitializer(() => {
  const initializerFn = loginFromStorage(inject(AuthDomainService));
  return initializerFn();
});
